// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__1j6TF","content":"Modal_content__GWH3C","contentChange":"Modal_contentChange__qAZwb"};